import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import i18n from '../services/i18n';

const SUPPORTED_LANGS = ['en', 'es', 'fr'];
const STORAGE_KEY = 'i18nextLng';

export function useLangFromQueryParam() {
	const [searchParams] = useSearchParams();
	const langParam = searchParams.get('lang');

	useEffect(() => {
		const targetLang = langParam && SUPPORTED_LANGS.includes(langParam)
			? langParam
			: localStorage.getItem(STORAGE_KEY);

		if (targetLang && SUPPORTED_LANGS.includes(targetLang)) {
			i18n.changeLanguage(targetLang);
			localStorage.setItem(STORAGE_KEY, targetLang);
			document.documentElement.lang = targetLang;
		}
	}, [langParam]);
}
